import React from "react";
import "../styles/Pages.css";
import ContactBand from "../components/ContactBand";
import grinding from "../assets/BH_diamond_grinding.jpg";
import drilling from "../assets/BH_core_drilling.jpg";
import properties from "../assets/BH_ceramic_properties.jpg";
import { capabilities, materials } from "../data/site";

export default function Capabilities() {
	return (
		<>
			<title>Capabilities | B & H Machining</title>
			<meta
				name="description"
				content="Diamond grinding, core drilling, CNC milling and turning, lapping and polishing of alumina ceramic, quartz, glass and metal parts."
			/>

			<section className="page-head">
				<div className="wrap">
					<h1>Capabilities</h1>
					<p className="lede">
						B & H machines a wide variety of parts and components to your specifications, from
						tubes, rings and wafers to armor, guideways and scientific components.
					</p>
				</div>
			</section>

			<section className="section feature-pair" aria-label="Core processes">
				<div className="wrap feature-pair__grid">
					<figure>
						<img src={grinding} alt="Diamond wheel grinding a ceramic plate" loading="lazy" />
						<figcaption>
							<h2>Diamond grinding</h2>
							<p>
								We fabricate precision parts from technical materials to close tolerances using
								diamond abrasive wheels, followed by lapping and polishing where the part calls
								for it.
							</p>
						</figcaption>
					</figure>
					<figure>
						<img src={drilling} alt="Core drill cutting through a ceramic block" loading="lazy" />
						<figcaption>
							<h2>Core drilling</h2>
							<p>
								Diamond core drills cut clean holes and cored blanks in ceramic, quartz and glass
								without chipping the edges of brittle material.
							</p>
						</figcaption>
					</figure>
				</div>
			</section>

			<section className="section section--alumina" aria-labelledby="all-processes">
				<div className="wrap">
					<div className="section-head">
						<h2 id="all-processes">Every process in-house</h2>
						<p>
							Fabrication, machining, grinding, honing, drilling, polishing, sawing, turning,
							milling and tapping. Design support is available for new parts.
						</p>
					</div>
					<dl className="spec-list">
						{capabilities.map((c) => (
							<div key={c.name}>
								<dt>{c.name}</dt>
								<dd>{c.text}</dd>
							</div>
						))}
					</dl>
				</div>
			</section>

			<section className="section" aria-labelledby="materials-title">
				<div className="wrap properties">
					<div className="properties__text">
						<h2 id="materials-title">Materials</h2>
						<p className="muted">
							Oxide ceramics such as aluminum oxide (Al₂O₃) are extremely resistant to wear and
							corrosion, with very high electrical insulating properties. The table shows
							typical properties by alumina content.
						</p>
						<dl className="spec-list spec-list--single">
							{materials.map((m) => (
								<div key={m.name}>
									<dt>{m.name}</dt>
									<dd>{m.text}</dd>
								</div>
							))}
						</dl>
					</div>
					<figure className="properties__table">
						<a href={properties} target="_blank" rel="noreferrer">
							<img
								src={properties}
								alt="Table of typical properties for alumina ceramics by alumina content, including flexural strength, hardness, thermal conductivity and dielectric strength"
								loading="lazy"
							/>
						</a>
						<figcaption className="muted">Typical ceramic properties. Select to enlarge.</figcaption>
					</figure>
				</div>
			</section>

			<ContactBand />
		</>
	);
}
